import React from 'react';
import PropTypes from 'prop-types';
import { TextCell } from '../cell/shared/Cells';
import { generateReactKey } from '../../utils/shared/commonUtils';
import { HOME_CONNECT_ENG_SPA_COL } from '../../constants/reading/DemoModeConstants';

const SimpleRow = ({
    id,
    columns,
    rowClassNames,
    cellClassNames,
    arrowClassNames,
    isSelected,
    onRowClick,
    headerCellsDataTestId,
}) => (
    <div
        data-test-id={headerCellsDataTestId}
        data-tour-step={HOME_CONNECT_ENG_SPA_COL}
        className={`${rowClassNames} ${isSelected ? 'selected' : ''}`}
        onClick={() => onRowClick(id)}
        role="presentation"
    >
        {columns.map((column, index) => (
            <TextCell
                key={generateReactKey(index)}
                content={column}
                classNames={`${cellClassNames} ${index === 0 ? 'first-cell' : ''}`}
                isDataCell={false}
            />
        ))}
        {isSelected && <i className={`pink-arrow-icon ${arrowClassNames}`} />}
    </div>
);

SimpleRow.defaultProps = {
    id: null,
    rowClassNames: '',
    cellClassNames: '',
    arrowClassNames: '',
    columns: [],
    isSelected: false,
    onRowClick: () => {},
    headerCellsDataTestId: '',
};

SimpleRow.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rowClassNames: PropTypes.string,
    cellClassNames: PropTypes.string,
    arrowClassNames: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
    isSelected: PropTypes.bool,
    onRowClick: PropTypes.func,
    headerCellsDataTestId: PropTypes.string,
};

export default SimpleRow;
